import About from "../components/About";
import Values from "../components/Values";
import Team from "../components/Team";

export default function AboutPage() {
  return (
    <div data-testid="about-page">
      <About />
      <Values />
      <Team />
    </div>
  );
}
